import { render, staticRenderFns } from "./ElementRedPacketComp.vue?vue&type=template&id=6689f21d&"
import script from "./ElementRedPacketComp.vue?vue&type=script&lang=js&"
export * from "./ElementRedPacketComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports